import React from "react";
import { Box } from "@chakra-ui/react";

export const ForestBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Dark forest gradient base */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #0a1f0a 0%, #1a3a1a 30%, #0d2a0d 70%, #061206 100%)"
      />

      {/* Layered tree silhouettes */}
      <svg
        className="forest-svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Tree gradients */}
          <linearGradient id="treeGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0a1f0a" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#051005" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="treeGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#153015" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#0a1a0a" stopOpacity="0.95" />
          </linearGradient>
          <linearGradient id="treeGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1f4a1f" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#0f2a0f" stopOpacity="0.85" />
          </linearGradient>

          {/* Light ray gradient */}
          <linearGradient id="lightRay" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#4a7a3a" stopOpacity="0.15" />
            <stop offset="50%" stopColor="#3a6a2a" stopOpacity="0.08" />
            <stop offset="100%" stopColor="#2a5a1a" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Light rays through canopy */}
        <g className="light-rays">
          <polygon fill="url(#lightRay)" points="200,0 280,0 380,800 100,800" opacity="0.5" />
          <polygon fill="url(#lightRay)" points="600,0 680,0 580,800 400,800" opacity="0.4" />
          <polygon fill="url(#lightRay)" points="1000,0 1080,0 1180,800 900,800" opacity="0.5" />
          <polygon fill="url(#lightRay)" points="1300,0 1380,0 1280,800 1100,800" opacity="0.3" />
        </g>

        {/* Back layer trees - tallest, darkest */}
        <g className="trees-back">
          <path
            fill="url(#treeGrad1)"
            d="M0,800 L0,350 L60,200 L120,380 L180,150 L240,400 L300,180 L360,350 L420,120 L480,380 L540,200 L600,350 L660,100 L720,380 L780,180 L840,400 L900,150 L960,350 L1020,200 L1080,380 L1140,120 L1200,350 L1260,180 L1320,400 L1380,200 L1440,350 L1440,800 Z"
          />
        </g>

        {/* Middle layer trees */}
        <g className="trees-middle">
          <path
            fill="url(#treeGrad2)"
            d="M0,800 L0,450 L80,300 L160,480 L240,280 L320,500 L400,320 L480,450 L560,250 L640,480 L720,300 L800,500 L880,280 L960,450 L1040,320 L1120,500 L1200,280 L1280,480 L1360,300 L1440,450 L1440,800 Z"
          />
        </g>

        {/* Front layer trees - closest, most detail */}
        <g className="trees-front">
          <path
            fill="url(#treeGrad3)"
            d="M0,800 L0,550 L100,420 L200,580 L300,400 L400,600 L500,450 L600,550 L700,380 L800,580 L900,420 L1000,600 L1100,400 L1200,550 L1300,420 L1440,580 L1440,800 Z"
          />
        </g>

        {/* Ground foliage */}
        <rect x="0" y="750" width="1440" height="50" fill="#051005" />
      </svg>

      {/* Floating particles (fireflies/dust) */}
      <Box className="forest-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(12)].map((_, i) => (
          <Box
            key={i}
            className={`firefly firefly-${i + 1}`}
            position="absolute"
            width="4px"
            height="4px"
            borderRadius="50%"
            backgroundColor="#8fdf6f"
            boxShadow="0 0 8px 2px rgba(143, 223, 111, 0.6)"
            opacity="0"
          />
        ))}
      </Box>

      {/* Leaf particles */}
      <Box className="leaf-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(6)].map((_, i) => (
          <Box
            key={i}
            className={`leaf leaf-${i + 1}`}
            position="absolute"
            width="8px"
            height="6px"
            backgroundColor="#2a5a2a"
            borderRadius="50% 0 50% 0"
            opacity="0"
            transform="rotate(45deg)"
          />
        ))}
      </Box>
    </Box>
  );
};

export default ForestBackground;
